import { useEffect } from "react";
import { useSession } from "../lib/auth-client";
import { useUserStore } from "../store/user-store";

export function useSessionSync() {
  const { data: session } = useSession();
  const setUser = useUserStore((s) => s.setUser);

  // Derive primitive/stable values to avoid re-running the effect when the
  // session object reference changes but the user data hasn't.
  const userId = session?.user?.id ?? null;
  const userName = session?.user?.name ?? null;
  const userEmail = session?.user?.email ?? null;
  const userImage = session?.user?.image ?? null;

  useEffect(() => {
    if (userId && userName && userEmail) {
      setUser({
        id: userId,
        name: userName,
        email: userEmail,
        image: userImage,
      });
    } else {
      setUser(null);
    }
  }, [userId, userName, userEmail, userImage, setUser]);
}
